/**
 * Centralized geocoding service
 * Replaces duplicate reverse geocoding logic
 */

/**
 * Reverse geocode coordinates to address
 * @param {number} latitude - Latitude
 * @param {number} longitude - Longitude
 * @returns {Promise<string>} Address string
 */
export const reverseGeocode = async (latitude, longitude) => {
  try {
    // Sử dụng CORS proxy hoặc bỏ qua nếu bị chặn
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`,
      {
        headers: {
          'User-Agent': 'ChamCongApp/1.0'
        },
        // Suppress CORS errors - geocoding is optional
        mode: 'cors'
      }
    ).catch(() => {
      // CORS error - return coordinates as fallback
      return null;
    });
    
    if (!response || !response.ok) {
      // Fallback to coordinates if geocoding fails
      return `${latitude}, ${longitude}`;
    }
    
    const data = await response.json();
    return data.display_name || `${latitude}, ${longitude}`;
  } catch (error) {
    // Suppress all errors - geocoding is optional, coordinates are sufficient
    // Fallback to coordinates if geocoding fails
    return `${latitude}, ${longitude}`;
  }
};
